module.exports = __webpack_public_path__ + "img/logo2.2a2a5175.png";